/**
 * Config API
 *
 * Network-only functions for onboarding configuration.
 * NO Redux imports allowed in this file.
 *
 * NOTE: This endpoint is excluded from authentication requirements
 * (no auth headers needed)
 */
import * as v from 'valibot';
import { type OnboardingConfig, ConfigApiResponseSchema } from '@contracts';
import { ONBOARDING_ENDPOINTS } from '@/api/endpoints';
import { fetchApi, validateApiResponse } from './apiUtils';

/**
 * Fetch onboarding configuration for initial load
 *
 * NOTE: This endpoint is excluded from authentication requirements
 * (no auth headers needed)
 */
export async function fetchOnboardingConfig(): Promise<OnboardingConfig> {
  const { data, response } = await fetchApi({
    url: ONBOARDING_ENDPOINTS.CONFIG,
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  });

  const parsedResponse = v.parse(ConfigApiResponseSchema, data);
  validateApiResponse(parsedResponse, response);

  return {
    heading: parsedResponse.heading ?? { greeting: '', question: '' },
    popularDestinations: parsedResponse.popularDestinations ?? [],
    globeDestinations: parsedResponse.globeDestinations ?? [],
  };
}
